module.exports = __webpack_public_path__ + "img/中间的碗图.266d5d0d.png";